import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ---------- generación IA ---------- */

export async function generateMessage(payload) {
  const { data } = await client.post('/messaging/generate', payload);
  return data;
}

export async function askCompetitors(question) {
  const { data } = await client.post('/messaging/ask-competitors', { question });
  return data;
}

/* ---------- biblioteca de materiales ---------- */

export async function listMaterials(params = {}) {
  const { data } = await client.get('/materials', { params });
  return data.materials || [];
}

export async function getMaterial(id) {
  const { data } = await client.get(`/materials/${id}`);
  return data.material;
}

export async function saveMaterial(payload) {
  const { data } = await client.post('/materials', payload);
  return data.material;
}

export async function updateMaterial(id, payload) {
  const { data } = await client.put(`/materials/${id}`, payload);
  return data.material;
}

export async function deleteMaterial(id) {
  await client.delete(`/materials/${id}`);
}

const messagingService = {
  generateMessage, askCompetitors,
  listMaterials, getMaterial, saveMaterial, updateMaterial, deleteMaterial,
};
export default messagingService;
